import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WalletConnect from './components/WalletConnect';
import Home from './pages/Home';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Roadmap from './pages/Roadmap';
import Storyline from './pages/Storyline';
import Characters from './pages/Characters';

function App() {
  return (
    <Router>
      <>
        <WalletConnect /> {/* Render WalletConnect globally */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/storyline" element={<Storyline />} />
          <Route path="/characters" element={<Characters />} />
        </Routes>
      </>
    </Router>
  );
}

export default App;
